module.exports = __webpack_public_path__ + "img/career-img.80417564.jpeg";